import axios from "axios";
import { authHeader } from "./headerConfig";

const MAX_RETRIES = 3;

const RETRY_INTERVAL = 1000;

const API_ENDPOINT = process.env.REACT_APP_ENDPOINT + "/api/x-admin";

const updateOrderNote = async (id, data) => {
  return await axios.put(`${API_ENDPOINT}/orders/${id}/note`, data, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
    },
  });
};

const getDailyOrdersInfo = async () => {
  const response = await axios.get(`${API_ENDPOINT}/orders/today-aggregates`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
    },
  });

  return response;
};
const getProgressOrders = async (page = 1) => {
  const response = await axios.get(
    `${API_ENDPOINT}/orders/inprogress?page=${page}`,
    {
      withCredentials: true,
      headers: {
        ...authHeader(),
        Accept: "application/json",
      },
    }
  );
  return response.data;
};

const getOrderLog = async (id) => {
  return await axios.get(`${API_ENDPOINT}/order-api-log/${id}`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
    },
  });
};
const updateOrderStatus = async (id, status) => {
  return await axios.put(`${API_ENDPOINT}/orders/${id}/${status}`, null, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
    },
  });
};

const getOrder = async (id) => {
  const response = await axios.get(`${API_ENDPOINT}/orders/${id}`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
    },
  });
  return response.data;
};

const getObfuscationId = async (id) => {
  let retries = 0;
  let errorResponse;

  while (retries < MAX_RETRIES) {
    try {
      const response = await axios.get(`${API_ENDPOINT}/obfuscation/${id}`, {
        withCredentials: true,
        headers: {
          ...authHeader(),
          Accept: "application/json",
        },
      });

      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 429) {
        await new Promise((resolve) => setTimeout(resolve, RETRY_INTERVAL));
        retries++;
        errorResponse = error.response;
      } else {
        throw error;
      }
    }
  }
  throw new Error(
    `Exceeded maximum number of retries (${MAX_RETRIES}). Last error: ${errorResponse}`
  );
};

const getDeObfuscationId = async (ObfuscationId) => {
  const response = await axios.get(
    `${API_ENDPOINT}/deobfuscation/${ObfuscationId}`,
    {
      withCredentials: true,
      headers: {
        ...authHeader(),
        Accept: "application/json",
      },
    }
  );
  return response.data.data.result;
};

const getAllOrders = async (page = 1) => {
  const response = await axios.get(`${API_ENDPOINT}/orders?page=${page}`, {
    withCredentials: true,
    headers: {
      ...authHeader(),
      Accept: "application/json",
    },
  });

  const ordersWithObfuscationIds = response.data;

  return ordersWithObfuscationIds;
};
const getAllOrdersWithSearch = async (page = 1, searchParam, searchQuery) => {
  const response = await axios.get(
    `${API_ENDPOINT}/orders?page=${page}&${searchParam}=${searchQuery}`,
    {
      withCredentials: true,
      headers: {
        ...authHeader(),
        Accept: "application/json",
      },
    }
  );
  const ordersWithObfuscationIds = response.data;
  return ordersWithObfuscationIds;
};

// const getAllOrders = async (page = 1) => {
//   try {
//     // استدعاء طلب الحصول على جميع الطلبات
//     const response = await axios.get(`${API_ENDPOINT}/orders?page=${page}`, {
//       withCredentials: true,
//       headers: {
//         ...authHeader(),
//         Accept: "application/json",
//       },
//     });

//     // استخراج بيانات الطلبات من الرد
//     const orders = response.data;
//     // console.log(orders);
//     // التأكد من أن البيانات عبارة عن مصفوفة
//     console.log(orders);

//     // الحصول على الهويات المخفية لكل طلب
//     const ordersWithObfuscationIds = await Promise.all(orders.map(async (order) => {
//       // استدعاء دالة getObfuscationId للحصول على الهوية المخفية
//       const obfuscationId = await getObfuscationId(order.id);
//       console.log(order);
//       // إرجاع الطلب مع الهوية المخفية
//       return {
//         ...order,
//         obfuscationId: obfuscationId,
//       };
//     }));
//     console.log(ordersWithObfuscationIds);

//     // إرجاع الطلبات بالهويات المخفية
//     return ordersWithObfuscationIds;
//   } catch (error) {
//     console.error("حدث خطأ أثناء جلب الطلبات:", error);
//     throw error; // إعادة رمي الخطأ
//   }
// };

const orderServices = {
  updateOrderNote,
  getOrder,
  getProgressOrders,
  getAllOrders,
  getOrderLog,
  updateOrderStatus,
  getDailyOrdersInfo,
  getAllOrdersWithSearch,
  getObfuscationId, //
  getDeObfuscationId, //
};

export default orderServices;
